import { render, staticRenderFns } from "./clientAccountDetails.vue?vue&type=template&id=38dbdca6&scoped=true"
import script from "./clientAccountDetails.vue?vue&type=script&lang=js"
export * from "./clientAccountDetails.vue?vue&type=script&lang=js"
import style0 from "./clientAccountDetails.vue?vue&type=style&index=0&id=38dbdca6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38dbdca6",
  null
  
)

export default component.exports